import { Modal, Button } from "react-bootstrap";

const AppModal = ({
  size,
  show,
  handleClose,
  modalTitle,
  children,
  buttons,
  onSubmit,
  currentId,
  closeButton = true,
  onOpen,
  disabledFunctional,
  disabledSubmit,
  confirmText = "Подтвердить",
  editText = "Изменить",
  closeText = "Закрыть",
}) => {
  const handleSubmit = () => {
    if (disabledSubmit) return alert("нужно заполнить все");
    onSubmit && onSubmit();
  };

  return (
    <Modal
      size={size}
      show={show}
      onHide={handleClose}
      onShow={onOpen}
      centered
      scrollable
      dialogClassName="appModalDialog"
      contentClassName="appModalContent"
      backdropClassName="appModalBackdrop"
    >
      {modalTitle ? (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
      ) : null}

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        {buttons ? (
          buttons.map((btn, index) => (
            <Button key={index} variant={btn.color} onClick={btn.onClick}>
              {btn.label}
            </Button>
          ))
        ) : (
          <>
            <Button variant="secondary" className="btn-sm" onClick={handleClose}>
              {closeText}
            </Button>
            {disabledFunctional ? null : (
              <Button
                disabled={disabledSubmit}
                variant="dark"
                className="btn-sm"
                onClick={handleSubmit}
              >
                {!currentId ? confirmText : editText}
              </Button>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AppModal;